import { runWithAdal } from "react-adal";
import { authContext } from "./auth/adalConfig";

//bypass this step because this is now managed within App.js by the `withAdalLoginApi`
const DO_NOT_LOGIN = true;

runWithAdal(
  authContext,
  () => {
    require("./indexApp");
  },
  DO_NOT_LOGIN
);
